import {DEBOUNCE_TIMEOUT} from "@/plugins/store/constants";

// Needs to implement searchQueryUpdated method in implementor component
export default {
  data (){
    return {
      searchQuery: '',
      searchDebounceTimeout: null,
    }
  },

  watch: {
    searchQuery(v) {
      if (v.trim().length === 0 || v.trim().length > 2) {
        window.clearTimeout(this.searchDebounceTimeout);
        this.searchDebounceTimeout = setTimeout(() => {
          this.searchQueryUpdated();
        }, DEBOUNCE_TIMEOUT)
      }
    }
  },

  methods: {
    searchQueryUpdated() {
      return null;
    }
  }

}